// extracted by mini-css-extract-plugin
export default {"cls1":"ImpactHubModal-cls1___5582843e2986342a909","cls2":"ImpactHubModal-cls2___548d5de843cf5bc0e39 ImpactHubModal-cls1___5582843e2986342a909"};